<div class="row mb-10">
  <div *ngFor="let item of dataHistoryHeader.value" class="col-lg-4">
    <app-card>
      <div cardBody class="p-3">
        <p class="text-gray-700 text fs-2">{{item.label}}</p>
        <h1>{{item.value}}</h1>
      </div>
    </app-card>
  </div>
</div>

<app-card>
  <ng-container cardBody>
    <ng-container
      *ngIf="baseDatasource.isTableLoaded && baseDatasource.totalItem$.getValue() === 0; else elseListBlock">
      <app-card-empty icon="{{iconNone}}" text="Belum terdapat data history qr."></app-card-empty>
    </ng-container>

    <ng-template #elseListBlock>
      <div class="table-responsive ">
        <table
          (matSortChange)="sortTable($event)"
          [dataSource]="baseDatasource"
          class="table w-100 gy-5 table-row-bordered align-middle"
          mat-table
          matSort
        >
          <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.key">
            <ng-container *ngIf="tableColumn.isSortable; else notSortable">
              <th
                *matHeaderCellDef
                [arrowPosition]="'after'"
                [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                [mat-sort-header]="tableColumn.key"
                class="min-w-125px px-3"
                mat-header-cell
              >
                <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject" [width]="70">
                  {{tableColumn.title}}
                </app-table-content>
              </th>
            </ng-container>
            <ng-template #notSortable>
              <th
                *matHeaderCellDef
                [class.min-w-200px]="tableColumn.key !== 'action' && tableColumn.key !== 'id'"
                [ngClass]="{
                  'min-w-70px text-center': tableColumn.key === 'action',
                  'w-250px': tableColumn.key === 'total_qr_generated'
                }"
                class="min-w-125px px-3"
                mat-header-cell
              >
                <app-table-content
                  [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                  [width]="70"
                >
                  {{tableColumn.title}}
                </app-table-content>
              </th>
            </ng-template>

            <!-- BEGIN::COLUMN DATA -->
            <td *matCellDef="let element" class="px-3" mat-cell>
              <ng-container [ngSwitch]="tableColumn.key">
                <div *ngSwitchCase="'action'">
                  <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject" [type]="'icon'">
                    <button class="btn btn-table-actions-download is-download mx-auto">
                      <span
                        (click)="handleAction()"
                        [inlineSVG]="STRING_CONSTANTS.ICON.IC_DOWNLOAD"
                      ></span>
                    </button>
                  </app-table-content>
                </div>

                <div *ngSwitchCase="'created_date'">
                  <app-table-content [count]="2" [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                                     [type]="'text'">
                    <div>{{ utilities.timeStampToDate(element['created_date'], 'dd-MM-yyyy') }}</div>
                    <div>{{ utilities.timeStampToDate(element['created_date'], 'HH:mm:ss') }}</div>
                  </app-table-content>
                </div>

                <div *ngSwitchCase="'created_by'">
                  <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                    <span>{{ element[tableColumn.key] }}</span>
                  </app-table-content>
                </div>

                <div *ngSwitchDefault>
                  <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                    <span>{{ element[tableColumn.key] && element[tableColumn.key] === 0 ? '-' : element[tableColumn.key] + ' Set' }}</span>
                  </app-table-content>
                </div>
              </ng-container>
            </td>
            <!-- END::COLUMN DATA -->
          </ng-container>
          <tr *matHeaderRowDef="displayedColumns" class="fw-bold text-start text-uppercase" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
        </table>
        <div class="d-flex justify-content-between py-4">
          <app-mai-material-bottom-table
            (changePage)="changePageEvent($event)"
            [baseDataTableComponent]="baseDatasource"
            [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
            class="w-100"
          ></app-mai-material-bottom-table>
        </div>
      </div>
    </ng-template>
  </ng-container>
</app-card>
